import React from 'react';

const HealthAppIcon: React.FC<{ className?: string }> = ({ className = 'w-full h-full' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path 
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V13H7V11H13V7H15V11H19V13H15V17H13Z" 
      fill="currentColor"
    />
    <path 
      d="M12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4ZM12 5C8.14 5 5 8.14 5 12C5 15.86 8.14 19 12 19C15.86 19 19 15.86 19 12C19 8.14 15.86 5 12 5Z" 
      fill="currentColor"
    />
  </svg>
);

export default HealthAppIcon;
